import { DRYBULK_CARGO_OPS_TELEMETRY } from "../constants";

export const closeOutContext = (action: string, operationId: string) => ({
  module: DRYBULK_CARGO_OPS_TELEMETRY.module,
  screen: DRYBULK_CARGO_OPS_TELEMETRY.operationScreen,
  action,
  entityType: "cargo_operation",
  entityId: operationId,
});
